import { ReactElement } from 'react';
import { NavigateFunction } from 'react-router-dom';

import { StyledLink, StyledLinkProps } from '../StyledLink';

export interface RouterLinkProps extends StyledLinkProps {
  /** Specifying: true will cause the navigation to replace the current entry in the history stack instead of adding a new one. */
  replace?: boolean;
  /** Optional state value to store in history state, which you can then access on the destination route via useLocation. */
  state?: any;
  /** When using the <ScrollRestoration> component, you can disable resetting the scroll to the top of the page. */
  preventScrollReset?: boolean;
  navigationHook: () => NavigateFunction;
  disableNavigation?: boolean;
}

/**
 * @description RouterLink component
 */
export function RouterLink({
  onClick,
  preventScrollReset,
  replace,
  state,
  to,
  navigationHook,
  disableNavigation,
  ...rest
}: RouterLinkProps): ReactElement {
  const navigate = navigationHook();

  function handleOnClick(event: React.MouseEvent<HTMLAnchorElement>): void {
    event.preventDefault();

    if (onClick) {
      onClick(event);
    }

    if (!disableNavigation && to) {
      navigate(to, { replace, state, preventScrollReset });
    }
  }

  return <StyledLink {...rest} to={to} onClick={handleOnClick} />;
}
